// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (-ms-high-contrast: active){._3pqC3lo6x:focus{transform:scale(1)}}\n", ""]);
// Exports
exports.locals = {
	"active": "_3pqC3lo6x"
};
module.exports = exports;
